import { defineStore } from "pinia";
import { computed, ref } from "vue";

import { userHeartbeatInterval } from "@/model/Settings";
import type { BoardUser } from "@/model/user";

import { useUserStore } from "./user";

export const useUsersOnBoardStore = defineStore("usersOnBoard", () => {
  const users = ref<BoardUser[]>([]);

  return {
    otherUsers: computed(() =>
      users.value.filter((user) => user.id !== useUserStore().technicalUser.id),
    ),

    resetUsers: () => (users.value = []),
    addUser: (user: BoardUser) =>
      (users.value = [user, ...users.value.filter(({ id }) => id !== user.id)]),
    removeUser: (userId: string) =>
      (users.value = users.value.filter((user) => user.id !== userId)),
    findUser: (userId: string) => users.value.find((user) => user.id === userId),
    expireUsers: () => {
      users.value = users.value.filter(
        (user) =>
          user.boardVisitTimestamp &&
          Date.now() - user.boardVisitTimestamp <= userHeartbeatInterval * 2,
      );
    },
  };
});
